<template>
    <div class="new-password-setup">
        <h2>You need to change your current password</h2>

        <p v-if="resetReason === 'admin_request'" class="alert alert-info">
            Your account administrator has requested that you reset your password in order to continue.
        </p>

        <p v-if="resetReason === 'password_breached'" class="alert alert-warning">
            Password you entered during login is marked as breached on other web sites. To ensure the security of this account, please
            change your password.
        </p>

        <p v-if="resetReason === 'maximum_password_age_exceeded'" class="alert alert-warning">
            Your password is older than maximum allowed password age and needs to be reset.
        </p>

        <PasswordChangeForm
            :is-processing="isLoading"
            :error-message="errorMessage"
            :current-password-required="false"
            @change-password="handlePasswordSetup"
        />
    </div>
</template>

<script>
import {resolveLoginAction} from "@/api/login";
import {useLoading} from "@/hooks/use-loading";
import {computed, ref} from "vue";
import PasswordChangeForm from "@/pages/common/PasswordChangeForm";

export default {
    name: "ForcePasswordReset",
    components: {
        PasswordChangeForm,
    },
    props: {
        action: Object
    },
    setup(props, {emit}) {
        const {isLoading, startLoading, stopLoading} = useLoading(false);

        const errorMessage = ref('');

        const resetReason = computed(() => props.action?.data.reason ?? 'admin_request');

        const handlePasswordSetup = async ({new_password}) => {
            errorMessage.value = '';

            startLoading();
            try {
                await resolveLoginAction({
                    action: 'force_reset_password',
                    data: {
                        password: new_password
                    }
                });

                emit('action-handled');
            } catch (e) {
                errorMessage.value = e?.response?.data?.message ?? 'Unknown error';
                stopLoading();
            }
        };

        return {
            isLoading,
            errorMessage,
            resetReason,
            handlePasswordSetup,
        }
    }
}
</script>

<style scoped lang="scss">
.new-password-setup {
    margin: 10px auto;

    h2 {
        font-size: 18px;
    }
}
</style>